import type { Hotspot, ObjectName } from "@/types";

export const HOTSPOTS: Record<
  Extract<
    ObjectName,
    | "book"
    | "monitor"
    | "pinBoard"
    | "switch"
    | "cube"
    | "keyboard"
    | "plant"
    | "fan"
    | "phone"
    | "cpu"
    | "mug"
  >,
  Hotspot
> = {
  book: { label: "about", shortcut: "a", action: "toggleBook" },
  monitor: { label: "browser", shortcut: "m", action: "openMonitor" },
  pinBoard: { label: "projects", shortcut: "p", action: "openProjects" },
  switch: { label: "theme", shortcut: "t", action: "toggleTheme" },
  cube: { label: "play", shortcut: "c", action: "focusCube" },
  keyboard: { label: "echo", shortcut: null, action: null },
  plant: { label: "plant", shortcut: null, action: "togglePlantBlurb" },
  fan: { label: "fps", shortcut: null, action: null },
  phone: { label: "contact", shortcut: "/", action: "openContact" },
  cpu: { label: "specs", shortcut: null, action: "toggleSpecs" },
  mug: { label: "caffeine", shortcut: null, action: "toggleMug" },
};

export type HotspotKey = keyof typeof HOTSPOTS;
